import {useEffect} from 'react'
import {SlctOnChangeState} from 'module/Slct/type/SlctType'

export function useSlctChangeState<ModelType extends object | void, ValueType extends string | number>(onChangeState: SlctOnChangeState | undefined, inputValue: string, focus: boolean) {
	useEffect(() => {
		if (onChangeState) onChangeState({inputValue, focus})
	}, [onChangeState, inputValue, focus])
}